import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { DealConfirmationImpl } from "../model/impl/DealConfirmationImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class DealConfirmationImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: DealConfirmationImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        DealConfirmationImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.bookingUTI != null) {
      this.baseEncoder.writeStartFid(220, streamout);
      this.baseEncoder.writeObject(
        false,
        DealConfirmationImplEncoder.fidTypeMap.get(220),
        false,
        encodable.bookingUTI,
        streamout,
      );
      this.baseEncoder.writeEndFid(220, streamout);
    }
    /*Object encoding*/
    if (encodable.acknowledged != null) {
      this.baseEncoder.writeStartFid(221, streamout);
      this.baseEncoder.writeObject(
        false,
        DealConfirmationImplEncoder.fidTypeMap.get(221),
        false,
        encodable.acknowledged,
        streamout,
      );
      this.baseEncoder.writeEndFid(221, streamout);
    }
    /*Object encoding*/
    if (encodable.descriptor != null) {
      this.baseEncoder.writeStartFid(222, streamout);
      this.baseEncoder.writeObject(
        false,
        DealConfirmationImplEncoder.fidTypeMap.get(222),
        false,
        encodable.descriptor,
        streamout,
      );
      this.baseEncoder.writeEndFid(222, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,DealConfirmationImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [100, "java.lang.String"],
    [220, "java.lang.String"],
    [221, "java.lang.Boolean"],
    [222, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: DealConfirmationImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealConfirmationImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 220: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealConfirmationImplEncoder.fidTypeMap.get(220),
            streamin,
          );
          encodable.bookingUTI = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 221: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            DealConfirmationImplEncoder.fidTypeMap.get(221),
            streamin,
          );
          encodable.acknowledged = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 222: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealConfirmationImplEncoder.fidTypeMap.get(222),
            streamin,
          );
          encodable.descriptor = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,DealConfirmationImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return DealConfirmationImplEncoder.fidTypeMap.has(fid);
  }
}
